<template>
  <v-container class="user-form">
    <span class="fibl-headline">
      {{ $t('userPasswordReset.headline') }}
    </span>
    <br />
    <v-card flat>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <p>
            {{$t('userPasswordReset.subtext1')}}
          </p>
          <p>
            {{$t('userPasswordReset.subtext2')}}
          </p>
          
          <v-text-field v-if= "isAuthenticated"
            class="above-align"
            name="email"
            :label="$t('userPasswordReset.mail')"
            type="email"
            clearable
            v-model="user.email"
            :rules="emailRules"
            required
            readonly
          >
          </v-text-field>

          <v-text-field v-else
            class="above-align"
            name="email"
            :label="$t('userPasswordReset.mail')"
            type="email"
            clearable
            v-model="email"
            :rules="emailRules"
            required
          >
          </v-text-field>
          
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-container>
          <v-row>
            <v-flex style="{text-align:center;}">
              <v-btn
                depressed
                class="button__primary"
                background-color="#FFFFFF"
                color="#2F6C86"
                :disabled="!valid"
                @click="submit"
              >
                {{ $t('userPasswordReset.reset') }}
              </v-btn>
            </v-flex>
          </v-row>

          <v-row>
            <a class="link__back" v-bind:href="back_url">
              {{ $t('userPasswordReset.back') }}
            </a>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UserPasswordReset",

 computed: {
    ...mapState(["user", "isAuthenticated", "message", "error"]),
  },

  data() {
    return {
      back_url: "/user/login",
      valid: false,
      email: "",
      emailRules: [
        (v) => !!v || this.$i18n.t('userPasswordReset.hint.mailRequired'),
        (v) => /.+@.+/.test(v) || this.$i18n.t('userPasswordReset.hint.mailInvalid'),
      ],
    };
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("reset", {
          email: this.email,
        });
      }
    },
  },
};
</script>
